// 소켓 연결 여부
export const SOCKET_CONNECTING = Symbol.for('SOCKET_CONNECTING');

declare global {
    interface Window {
        [SOCKET_CONNECTING]: boolean;
    }
}
